<template>
    <div class="row justify-content-center">
      <div class="col-lg-6 mt-2">
        <b-tabs>
          <b-tab
            :title="`${this.$t('menu.settings.accountData.customFilters')}`"
            active
          >
            <idx-card
              :title="`${this.$t('menu.settings.accountData.customFilters')}`"
            >
              <div class="row">
                <div class="col-6">
                  <div class="input-area">
                    <button v-b-modal.modal-add class="btn btn-primary">
                      Novo filtro personalizado
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-4">
                  <b-table striped :items="items" :fields="fields">
                    <template v-slot:cell(start)="row">
                       {{ formatDate(row.item.start) }}
                    </template>
                    <template v-slot:cell(end)="row">
                       {{ formatDate(row.item.end) }}
                    </template>
                    <template v-slot:cell(action)="row">
                      <div class="text-center">
                        <button
                          :id="`filter-pen-${row.item._id}`"
                          @click="editFilter(row.item, row.index)"
                          class="btn btn-outline-primary"
                          style="display: inline;"
                        >
                          <font-awesome-icon :icon="['fas', 'pen']" />
                        </button>
                        <button
                          :id="`filter-trash-${row.item._id}`"
                          class="btn btn-outline-danger"
                          @click="deleteFilter(row.index)"
                          style="display: inline;"
                        >
                          <font-awesome-icon :icon="['fas', 'trash-alt']" />
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </idx-card>
          </b-tab>
        </b-tabs>
      </div>
  
      <b-modal
        id="modal-add"
        title="Adicionar filtro personalizado"
        size="lg"
        ok-only
        scrollable
        :hide-footer="true"
      >
        <Add :filters="items"/>
      </b-modal>
  
      <b-modal
        id="modal-edit"
        title="Editar filtro personalizado"
        size="lg"
        ok-only
        scrollable
        :hide-footer="true"
      >
        <Edit :filter="filter" :filters="items" :index="index" />
      </b-modal>
    </div>
  </template>
  
  <script>
  import IdxCard from '@/components/molecules/idx-card';
  import swal from 'sweetalert';
  import { mapActions } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import * as moment from 'moment';
  import api from '../../../services/api';
  import Add from './add';
  import Edit from './edit';
  
  export default {
    components: { IdxCard, Add, Edit },
  
    data: () => ({
      loading: false,
      userAuth: null,
      fields: [],
      items: [],
      newFilter: {
        name: null,
        start: null,
        end: null,
      },
      filter: null,
      index: null
    }),

    computed: {
        ...mapFields('companies', ['company']),
    },
  
    methods: {
        ...mapActions('companies', ['getCompany']),

      async deleteFilter(index) {
        swal({
          title: 'Atenção!',
          text: 'Quer mesmo excluir este filtro?',
          icon: 'warning',
          buttons: [
            this.$t('menu.settings.accountData.subCategory.cancelDescription'),
            this.$t('menu.settings.accountData.subCategory.deleteDescription'),
          ],
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            try {
                this.items.splice(index, 1);
                await api.put(
                    `/company/custom-filters/${this.userAuth.companyId}`,
                    {
                    customFilters: this.items,
                    },
                    {
                    headers: {
                        'x-access-token': this.userAuth.token,
                    },
                    },
                );
                swal('Sucesso', 'Filtro personalizado excluído com sucesso!', 'success');
                this.$bvModal.hide('modal-add');
                } catch (error) {
                window.console.log(error);
            }
          }
        });
      },
  
      editFilter(item, index) {
        this.filter = item;
        this.index = index;
        setTimeout(() => {
          this.$bvModal.show('modal-edit');
        }, 100);
      },
  
      async getCustomFilters() {
          await this.getCompany({
            id: this.userAuth.companyId,
            token: this.userAuth.token,
          });

        this.items = this.company.customFilters || [];
          
      },
      
      formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
      
    },
  
    async mounted() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
      await this.getCustomFilters();
  
      this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        if (modalId === 'modal-add') {
          this.getCustomFilters();
        }
      });
    },
    created() {
      this.fields = [
        {
          key: 'name',
          label: 'Nome do filtro',
          sortable: true,
        },
        {
          key: 'start',
          label: 'Data inicial',
          sortable: true,
        },
        {
          key: 'end',
          label: 'Data final',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Editar',
          class: 'text-center',
        },
      ];
    },
  };
  </script>
  
  <style scoped>
  .input-area {
    display: flex;
    flex-direction: row;
  }
  </style>
  
  <style>
  .action-list-item {
    padding: 8px;
    border-bottom: solid 1px #cccccc;
    background: #ffffff;
    vertical-align: middle;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/molecules/custom-filter-date/index.vue